import React from "react";

import { Button, IconButton, InputAdornment, TextField } from '@mui/material';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CustomTextField from "../../../../GlobalComponents/CustomComponant/CustomTextField";


function NewUser() {

const [loginname, setloginname] = React.useState("");
const [userfname, setuserfname] = React.useState("");
const [email, setemail] = React.useState("");
const [mobile, setmobile] = React.useState("");
const [newPassword, setNewPassword] = React.useState("");
const [confirmPassword, setConfirmPassword] = React.useState("");
const [showPassword, setShowPassword] = React.useState(false);
const [errors, setErrors] = React.useState({
  newPassword: "",
  confirmPassword: "",
});
const handleClickShowPassword = () => {
  setShowPassword(!showPassword);
}
const handleSubmit = () => {
  const newErrors = {};
  // Check if fields are empty
  if (!loginname) {
    newErrors.loginname = "Login User Name is required";
  }
  if (!userfname) {
    newErrors.userfname = "User Full Name is required";
  } 
  if (!email) {
    newErrors.email = "E-Mail is required";
  }
  if (!mobile) {
    newErrors.mobile = "Mobile Number is required";
  }
  if (!newPassword) {
    newErrors.newPassword = "New password is required";
  }
  if (!confirmPassword) {
    newErrors.confirmPassword = "Confirm password is required";
  }
  // Password complexity checks (only if newPassword is not empty)
  if (newPassword) {

    if (newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters long";
    }

    else if (!/[A-Z]/.test(newPassword)) {
      newErrors.newPassword = "Password must contain at least one uppercase letter";
    }
    else if (!/[a-z]/.test(newPassword)) {
      newErrors.newPassword = "Password must contain at least one lowercase letter";
    } else if (!/[0-9]/.test(newPassword)) {
      newErrors.newPassword = "Password must contain at least one number";
    } else if (!/[!@#$%^&*]/.test(newPassword)) {
      newErrors.newPassword = "Password must contain at least one special character";
   
    }
  } 
  // Confirm password checks
  if (confirmPassword) {
    if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    } else if (confirmPassword.length < 8) {
      newErrors.confirmPassword = "Confirm password must be at least 8 characters long";
    }
  } 
  // Set errors state
  setErrors(newErrors);
  // Check if there are any errors
  if (Object.keys(newErrors).length === 0) {
    // No errors, proceed with form submission
    console.log("Form submitted successfully!");
    // Add your form submission logic here
  } else {
    console.log("Form has errors:", newErrors);
  }   
}
  // Function to handle form submission


  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setemail(value);

    // Validate format
    if (value && !emailRegex.test(value)) {
      setErrors("Invalid email format");
    } else {
      setErrors("");
    }
  };






  const handleFormSubmit = (event) => {
    event.preventDefault();
    // Perform validation and submission logic here
  };
  // Function to handle input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    // Update the corresponding state variable based on the input name
    switch (name) {
      case "loginname":
        setloginname(value);
        break;
      case "userfname":
        setuserfname(value);
        break;
      case "email":
        setemail(value);
        break;
      case "mobile":
        setmobile(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };
  // Function to handle password visibility toggle
  const handlePasswordVisibilityToggle = () => {
    setShowPassword(!showPassword);
  };    

  // Function to handle cancel action
  const handleCancel = () => {
    // Handle the cancel action here
    console.log("Form cancelled!");
  };
  // Function to handle form reset
  const handleFormReset = () => {
    // Reset all state variables to their initial values
    setloginname("");
    setuserfname("");
    setemail("");
    setmobile("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
  };
  






  return (
    <div>
      <div className="container">
        <div className="input-group">
          <CustomTextField
            label="Login User Name"
            value={loginname ?? ""}
            onChange={(e) => {
              setloginname(e.target.value);
            }}
            placeholder="Login User Name"
            maxLength={100} // Set the maximum length
          // error={!!errors.err}
          //  helperText={errors.err}
          />
        </div>


        <div className="input-group">
          <CustomTextField
            label="User Full Name"
            value={userfname ?? ""}
            onChange={(e) => {
              setuserfname(e.target.value);
            }}
            placeholder="User Full Name"
            maxLength={100} // Set the maximum length
          // error={!!errors.err}
          //  helperText={errors.err}
          />
        </div>


        
   </div>


      <div className="container">
        <div className="input-group">
          <CustomTextField
            label="E-Mail"
            value={email ?? ""}
            // onChange={(e) => {
            //   setemail(e.target.value);
            // }}
            onChange={handleEmailChange}
            placeholder="E-Mail"
            maxLength={100} // Set the maximum length
          // error={!!errors.err}
          //  helperText={errors.err}
          />
        </div>


        <div className="input-group">
          <CustomTextField
            label="Mobile"
            value={mobile ?? ""}
            onChange={(e) => {
              setmobile(e.target.value);
            }}
            placeholder="Mobile Number"
            maxLength={100} // Set the maximum length
          // error={!!errors.err}
          //  helperText={errors.err}
          />
        </div>
      </div>

      <div className="container">
        <div className="input-group">
          <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            label="Password"
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            error={!!errors.newPassword}
            helperText={errors.newPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>



        <div className="input-group">
          <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            label="Confirm Password"
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    edge="end"
                    aria-label="toggle password visibility"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>


      <div className="container">
        <div className="input-group">
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div></div>

      </div>
      )
}

      export default NewUser